var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-overlay", { attrs: { show: _vm.is_load, rounded: "sm" } }, [
        _c("div", { staticClass: "panel-tag" }, [
          _vm._v("\n\t\t\t" + _vm._s(_vm.__t("CITY_TAG_PUBLISH")) + "\n\t\t"),
        ]),
        _vm._v(" "),
        _c("h5", { staticClass: "frame-heading" }, [
          _vm._v(_vm._s(_vm.__t("PUBLISHED_TTL"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "custom-control custom-checkbox custom-control-inline",
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.city.published,
                  expression: "city.published",
                },
              ],
              staticClass: "custom-control-input",
              attrs: { type: "checkbox", id: "publish" },
              domProps: {
                checked: Array.isArray(_vm.city.published)
                  ? _vm._i(_vm.city.published, null) > -1
                  : _vm.city.published,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.city.published,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        _vm.$set(_vm.city, "published", $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.city,
                          "published",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(_vm.city, "published", $$c)
                  }
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "custom-control-label",
                attrs: { for: "publish" },
              },
              [_vm._v(_vm._s(_vm.__t("PUBLISHED")))]
            ),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "skeep_sync mt-5" }, [
          _c("h5", { staticClass: "frame-heading" }, [
            _vm._v(_vm._s(_vm.__t("SKEEP_TTL"))),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "custom-control custom-checkbox custom-control-inline",
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.city.skeep_sync,
                    expression: "city.skeep_sync",
                  },
                ],
                staticClass: "custom-control-input",
                attrs: { type: "checkbox", id: "skeep_sync" },
                domProps: {
                  checked: Array.isArray(_vm.city.skeep_sync)
                    ? _vm._i(_vm.city.skeep_sync, null) > -1
                    : _vm.city.skeep_sync,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.city.skeep_sync,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(_vm.city, "skeep_sync", $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.city,
                            "skeep_sync",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.city, "skeep_sync", $$c)
                    }
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "custom-control-label",
                  attrs: { for: "skeep_sync" },
                },
                [_vm._v(_vm._s(_vm.__t("SKEEP_SYNC")))]
              ),
            ]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }